// ─────────────────────────────────────────────────────────────
// Route constants — never hardcode path strings in components.
// Always import from here.
// ─────────────────────────────────────────────────────────────

export const ROUTES = {
  // Public
  LANDING:          '/',
  LOGIN:            '/login',
  SIGNUP:           '/signup',
  PRIVACY:          '/privacy',
  TERMS:            '/terms',
  CONTACT:          '/contact',
  FORGOT:           '/forgot-password',
  NOT_FOUND:        '*',

  // Auth callbacks
  AUTH_CALLBACK:    '/auth/callback',
  AUTH_REDEEM:      '/auth/redeem',
  AUTH_RESET:       '/auth/reset-password',
  AUTH_CONSENT:     '/auth/consent',

  // Auth-gated — COPPA pending
  PENDING_CONSENT:  '/pending-consent',

  // Auth-gated — onboarding
  ONBOARDING:       '/onboarding',
  DIAGNOSTIC:       '/diagnostic',

  // Auth-gated — student (AppShell)
  HOME:             '/home',
  PRACTICE:         '/practice',
  QUIZ:             '/quiz',
  RESULTS:          '/results',
  PROGRESS:         '/progress',
  SETTINGS:         '/settings',

  // Paywall / billing
  PAYWALL:          '/paywall',
  SUB_SUCCESS:      '/subscription/success',

  // AP exam prep — public entry points
  AP_LANDING:  '/ap-prep',
  AP_LOGIN:    '/ap/login',
  AP_SIGNUP:   '/ap/signup',

  // AP exam prep module (separate from K-12)
  AP_HUB:                '/ap',
  AP_PAYWALL:            '/ap/paywall',
  AP_PRACTICE:           '/ap/practice',
  AP_RESULTS:            '/ap/results',
  AP_PROGRESS:           '/ap/progress',
  AP_DIAGNOSTIC:         '/ap/diagnostic',
  AP_DIAGNOSTIC_RESULTS: '/ap/diagnostic/results',
  AP_FRQ:                '/ap/frq',
  AP_PLAN:               '/ap/:examId/plan',
  AP_BILLING:            '/ap/billing',
  AP_MOCK_EXAM:          '/ap/:examId/mock',
  AP_REVIEW_QUEUE:       '/ap/:examId/review',
  AP_VOCAB:              '/ap/:examId/vocab',

  // Public — standalone FAQ
  FAQ:              '/faq',

  // Auth-gated — parent dashboard
  PARENT:           '/parent',
  // PARENT_SESSIONS and PARENT_SETTINGS removed — Phase 8 stubs with no
  // Route element or page component. Add back when pages are implemented.
  PARENT_BILLING:   '/parent/billing',
  PARENT_CANCEL:    '/parent/cancel',
} as const

export type AppRoute = typeof ROUTES[keyof typeof ROUTES]

/** Routes that show the BottomNav */
export const BOTTOM_NAV_ROUTES: AppRoute[] = [
  ROUTES.HOME,
  ROUTES.PROGRESS,
  ROUTES.SETTINGS,
]

/** Routes that require an active subscription (ProtectedRoute gate 3) */
export const GATED_ROUTES: AppRoute[] = [
  ROUTES.PRACTICE,
  ROUTES.QUIZ,
  ROUTES.PROGRESS,
]

/** Routes with LeaveGuard active (student must confirm before leaving) */
export const LEAVE_GUARD_ROUTES: AppRoute[] = [
  ROUTES.PRACTICE,
  ROUTES.QUIZ,
]
